import { client, unwrap } from './client';

/**
 * Lightweight operator profile returned by the magic-link verify
 * endpoint. The server returns more fields than this; we only persist
 * what the sidebar + topbar need so localStorage stays compact and
 * stale-data risk stays low.
 */
export interface OperatorSummary {
  id: string;
  name: string;
  email: string;
  companyName: string | null;
  accountType: string; // always 'hosting' for this surface
  publisherKey: string;
}

export async function requestMagicLink(email: string): Promise<void> {
  await client.post('/fleet/auth/request-link', { email });
}

export async function verifyMagicLink(
  token: string
): Promise<{ token: string; operator: OperatorSummary }> {
  return unwrap(client.post('/fleet/auth/verify', { token }));
}
